<template>
    <div>
        <vs-table search stripe border description :sst="true" :data="table.data" :max-items="table.length"
            :total="table.total" @search="handleSearch" @change-page="handleChangePage" @sort="handleSort">
            <template slot="header">
                <vs-dropdown vs-trigger-click class="cursor-pointer">
                    <div class="p-3 border border-solid d-theme-border-grey-light rounded-full d-theme-dark-bg cursor-pointer flex items-center justify-between font-medium">
                        <span class="mr-2">{{ this.table.start }} - {{ this.table.end }} of {{ this.table.total }}</span>
                        <feather-icon icon="ChevronDownIcon" svgClasses="h-4 w-4" />
                    </div>
                    <vs-dropdown-menu>
                        <vs-dropdown-item v-for="item in table.limits" :key="item" @click="handleChangelength(item)">
                            <span>{{ item }}</span>
                        </vs-dropdown-item>
                    </vs-dropdown-menu>
                </vs-dropdown>
            </template>
            <template slot="thead">
                <vs-th width="10%"></vs-th>
                <vs-th sort-key="code">Bill Of Material ID</vs-th>
                <vs-th sort-key="description">Description</vs-th>
                <vs-th sort-key="purpose">Purpose</vs-th>
                <vs-th sort-key="">Date</vs-th>
            </template>

            <template slot-scope="{ data }">
                <vs-tr :data="tr" :key="indextr" v-for="(tr, indextr) in data">
                    <vs-td>
                        <div class="vx-input-group flex">
                            <vs-button size="small" color="warning" icon-pack="feather" icon="icon-edit" title="Edit"
                            v-if="status === 0 && hasPermission('edit')" style="margin-right: 5px" @click.stop="handleEdit(tr.id)"  />
                            <vs-button size="small" color="warning" icon-pack="feather" icon="icon-eye" title="Detail"
                            v-if="status !== 0 && hasPermission('view')" style="margin-right: 5px" @click.stop="handleShow(tr.id)"/>
                            <vs-button size="small" color="success" icon-pack="feather" icon="icon-check" title="Activate"
                            v-if="(status === 2 || status === 0) && hasPermission('activation')" style="margin-right: 5px" @click.stop="handleApprove(tr.id)"/>
                            <vs-button size="small" color="danger" icon-pack="feather" icon="icon-x" title="Cancel"
                            v-if="status === 0 && hasPermission('cancel')" style="margin-right: 5px" @click.stop="handleCancel(tr.id)"/>
                            <vs-button size="small" color="danger" icon-pack="feather" icon="icon-x" title="Deactivate"
                            v-if="status === 1 && hasPermission('activation')" style="margin-right: 5px" @click.stop="handleDeactivate(tr.id)"/>
                        </div>
                    </vs-td>
                    <vs-td>{{ tr.code }}</vs-td>
                    <vs-td>{{ tr.description }}</vs-td>
                    <vs-td>{{ tr.purpose == 0 ? "SKU-ID Change" : "Repackaging" }}</vs-td>
                    <vs-td>{{ tr.date }}</vs-td>
                </vs-tr>
            </template>
        </vs-table>
        <vs-pagination style="padding-top: 5px" :total="table.totalPage" v-model="setPage" />
    </div>
</template>

<script>
import moment from "moment";
export default {
    props: {
        baseUrl: {
            type: String,
        },
        title: {
            type: String,
        },
        action: {
            type: String,
        },
        status: {
            type: Number,
        },
    },
    data() {
        return {
            table: this.tableState(),
        };
    },
    methods: {
        tableState() {
            return {
                data: [],
                length: 10,
                page: 1,
                search: "",
                order: "ID",
                sort: "desc",
                total: 0,
                totalPage: 0,
                totalSearch: 0,
                limits: [10, 25, 50, 100, "All"],
                start: 1,
                end: 0,
            };
        },
        handleSearch(searching) {
            this.table.search = searching;
            this.table.page = 1;
            this.getData();
        },
        handleChangePage(page) {
            this.table.page = page;
            this.getData();
        },
        handleSort(key, active) {
            if (active) {
                this.table.order = key;
                this.table.sort = active;
            } else {
                this.table.order = "ID";
                this.table.sort = "desc";
            }
        },
        handleChangelength(val) {
            this.table.length = val == "All" ? this.table.total : val;
            this.table.page = 1;
            this.getData();
        },
        getData() {
            this.$vs.loading();
            this.$http.get(this.baseUrl + "/list", {
                params: {
                    length: this.table.length,
                    page: this.table.page,
                    search: this.table.search,
                    order: this.table.order,
                    sort: this.table.sort,
                    status: Number(this.status),
                },
            })
            .then((resp) => {
                console.log(resp.data);
                if (resp.code == 200) {
                    this.table.total = resp.data.total_record;
                    this.table.totalPage = resp.data.total_page;
                    this.table.totalSearch = resp.data.total_record_search;
                    this.table.length = resp.data.total_record_per_page;
                    this.table.data = resp.data.records;
                    this.$emit("isFilter", false);

                    console.log(">>>>>>>>>", this.table.data);
                    this.$vs.loading.close();
                } else {
                    console.log(resp.data);
                    this.$vs.loading.close();
                }
            });
        },
        setStartEnd() {
            let valStart = this.table.length * this.table.page - this.table.length + 1;
            if (valStart > this.table.total) {
                valStart = 1;
            }
            if (this.table.total == 0) {
                valStart = 0;
            }
            let valEnd = this.table.length * this.table.page;
            if (valEnd > this.table.total) {
                valEnd = this.table.total;
            }
            if (this.table.totalSearch < this.table.total) {
                valEnd = this.table.totalSearch;
            }

            this.table.start = valStart;
            this.table.end = valEnd;
        },
        handleEdit(id) {
            this.$router.push({
                name: "bill-of-material-edit",
                params: { id: id },
            });
        },
        handleShow(id) {
            this.$router.push({
                name: "bill-of-material-show",
                params: { id: id },
            });
        },
        handleApprove(id) {
            this.$vs.dialog({
                type: "confirm",
                color: "danger",
                title: `Confirm`,
                text: "Are you sure to activate this data?",
                accept: () => {
                    this.$vs.loading();
                    this.$http.post("api/wms/v1/item-bill-of-material/update-status", {
                        id: id,
                        status: 1,
                    })
                    .then((resp) => {
                        this.$vs.loading.close();
                        if (resp.code == 200) {
                            this.$vs.notify({
                                color: "success",
                                title: "Success",
                                text: "The data was successfully Activated",
                                position: "top-right",
                                iconPack: "feather",
                                icon: "icon-x-circle",
                            });
                        } else {
                            this.$vs.notify({
                                color: "danger",
                                title: "Error",
                                text: resp.message,
                                position: "top-right",
                                iconPack: "feather",
                                icon: "icon-x-circle",
                            });
                        }
                        this.getData();
                    })
                    .catch((error) => {
                        this.$vs.loading.close();
                        console.log(error);
                    });
                }
            });
        },
        handleCancel(id) {
            this.$vs.dialog({
                type: "confirm",
                color: "danger",
                title: `Confirm`,
                text: "Are you sure to cancel this data?",
                accept: () => {
                    this.$vs.loading();
                    this.$http.post("api/wms/v1/item-bill-of-material/update-status", {
                        id: id,
                        status: 3,
                    })
                    .then((resp) => {
                        this.$vs.loading.close();
                        if (resp.code == 200) {
                            this.$vs.notify({
                                color: "success",
                                title: "Success",
                                text: "The data was successfully canceled",
                                position: "top-right",
                                iconPack: "feather",
                                icon: "icon-x-circle",
                            });
                        } else {
                            this.$vs.notify({
                                color: "danger",
                                title: "Error",
                                text: resp.message,
                                position: "top-right",
                                iconPack: "feather",
                                icon: "icon-x-circle",
                            });
                        }
                        this.getData();
                    })
                    .catch((error) => {
                        this.$vs.loading.close();
                        console.log(error);
                    });
                }
            });
        },
        handleDeactivate(id) {
            this.$vs.dialog({
                type: "confirm",
                color: "danger",
                title: `Confirm`,
                text: "Are you sure to deactivate this data?",
                accept: () => {
                    this.$vs.loading();
                    this.$http.post("api/wms/v1/item-bill-of-material/update-status", {
                        id: id,
                        status: 2,
                    })
                    .then((resp) => {
                        this.$vs.loading.close();
                        if (resp.code == 200) {
                            this.$vs.notify({
                                color: "success",
                                title: "Success",
                                text: "The data was successfully deactivated",
                                position: "top-right",
                                iconPack: "feather",
                                icon: "icon-x-circle",
                            });
                        } else {
                            this.$vs.notify({
                                color: "danger",
                                title: "Error",
                                text: resp.message,
                                position: "top-right",
                                iconPack: "feather",
                                icon: "icon-x-circle",
                            });
                        }
                        this.getData();
                    })
                    .catch((error) => {
                        this.$vs.loading.close();
                        console.log(error);
                    });
                }
            });
        },
    },
    mounted() {
      this.$store.dispatch("user/getPermissions", "bill-of-material");
    },
    computed: {
        setPage: {
            get() {
                return 1;
            },
            set(val) {
                this.handleChangePage(val);
            },
        },
    },
    filters: {
        formatDate(value) {
            if (value) {
                return moment(value).add(-7, "h").utc().local().format("DD MMM YYYY");
            }
        },
    },
    watch: {
        action(val) {
            this.getData();
            this.mutableAction = val;
        },
    },
};
</script>
